import * as React from 'react';
import { withLocalize, LocalizeContextProps } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import InfoBox from "src/components/mission/InfoBox";

interface SpaceStation4Props extends EnhancedProps, LocalizeContextProps {
}

interface SpaceStation4State {
    translationKey: string;
    translationStep: number;
    translationArray: string[];
}

class SpaceStation4 extends React.Component<SpaceStation4Props, SpaceStation4State> {
    constructor(props: SpaceStation4Props) {
        super(props);
        bindAllOfThis(this, SpaceStation4.prototype);

        this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillReceiveProps(nextProps: SpaceStation4Props) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return true;
    }

    onNext() {
        // Update the state step first
        let step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            } as SpaceStation4State);
            return;
        }
        this.props.onNext();
    }

    onBack() {
        // Update the state step first (go backwards)
        let step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            } as SpaceStation4State);
            return;
        }
        this.props.onBack();
    }

    deriveStateFromProps(newProps: SpaceStation4Props) {
        let translatedKey = "student.welcome.grade%gradeNumber%.page4"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        let translatedText = newProps.translate(translatedKey).toString();
        let translatedArray = (translatedText || "").split("|").map(x => x.trim());
        let translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;

        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        } as SpaceStation4State);
    }

    render() {
        let currentDialog: string = (this.state.translationArray || [""])[this.state.translationStep];
        let translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = `${translationKey}.part${this.state.translationStep + 1}`;
        }
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <Row>
            <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} xl={14}>
                <Row>
                    <DialogBox
                        currentGrade={this.props.currentGrade}
                        currentPlanet={this.props.currentPlanet}
                        buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                        buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                        onBack={this.onBack}
                        onNext={this.onNext}>
                        <p>{currentDialog}</p>
                    </DialogBox>
                </Row>
            </Col>
            <Col xs={23} md={{ span: 7, push: 1 }} xl={9}>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 23, push: 1 }} lg={{ span: 20, push: 4 }}>
                        <InfoBox
                            currentGrade={this.props.currentGrade}
                            currentPlanet={this.props.currentPlanet} />
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 20, push: 2 }} lg={{ span: 21, push: 1 }}>
                        <img className="station-commander" alt={`Commander ${this.props.currentGrade.commander}`} src={this.props.currentGrade.commanderPath} height="100%" width="100%" />
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}

export default withLocalize(SpaceStation4);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/SpaceStation4.tsx